import { useGetGeneralDataQuery, useIsAuthenticated } from '@/features/auth';

import { fullNameOf } from './fullName';

export interface CurrentUser {
  fullName: string;
  email: string;
  /** ASIC's id for this director. Identifies them as a signatory — an invite
   *  has to say who sent it. */
  memberId: string;
  /** False while the record is still loading, so the UI can show a skeleton
   *  rather than an avatar with empty initials. */
  isLoaded: boolean;
}

/**
 * The signed-in director, for display.
 *
 * The name is assembled from ASIC's four name fields rather than a single
 * `fullName` the API does not return — see `fullNameOf`.
 *
 * The query is skipped without a session — requesting the record while logged
 * out would 401 on every render of the shell.
 */
export const useCurrentUser = (): CurrentUser => {
  const isAuthenticated = useIsAuthenticated();
  const { data } = useGetGeneralDataQuery(undefined, { skip: !isAuthenticated });

  if (!data) {
    return { fullName: '', email: '', memberId: '', isLoaded: false };
  }

  return {
    fullName: fullNameOf(data),
    email: data.email,
    memberId: data.asicMemberId,
    isLoaded: true,
  };
};
